import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const DesktopOnly = styled.div`
  ${media.mediumDown`
    display:none;
  `}
`;

export const MediumUp = styled.div<{ $hide?: boolean }>`
  ${p =>
    p.$hide &&
    css`
      display: none;
    `}

  ${media.smallOnly`
    display:none;
  `}
`;

export const MobileOnly = styled.div`
  ${media.mediumUp`
    display: none;
  `}
`;
